import AdvancedSelect from "@/components/common/advanced-select/AdvancedSelect.vue";
import { sidebarWidth as sidebarWidthState, toggleSidebar  } from "@/components/sidebar/state.js";

export default {
    name: 'PageHeader',

    components: {
        AdvancedSelect
    },

    data() {
        return {
            companyOptions: [],
            loading: false,
        }
    },

    computed: {
        isShowAllCompany() {
            return this.$store.getters.hasPermission(
                '21232f297a57a5a743894a0e4a801fc3'
            )
        },

        sidebarWidth() {
            return sidebarWidthState.value
        },

        companyId: {
            get() {
                return this.$store.state.companyId
            },
            set(value) {
                this.$store.commit('setCompanyId', value)
            }
        }
    },

    watch: {
        isShowAllCompany: {
            immediate: true,
            handler(val) {
                if (val && !this.companyOptions.length) {
                    this.populateData()
                }
            }
        }
    },

    methods: {
        toggleSidebar,
        async populateData() {
            if (!this.isShowAllCompany || this.loading) return

            this.loading = true
            try {
                const result = await this.getCompanyOptions()
                this.companyOptions = result.data?.companyOptions || []
            } finally {
                this.loading = false
            }
        },

        async getCompanyOptions() {
            return this.ApiRequest.requestAsync(
                'company/options',
                this.ApiRequest.REQUEST_GET,
                [],
                'company-options',
                true
            )
        },

        onChangeCompany(companyId) {
            const value = companyId ?? ''
            this.$store.commit('setCompanyId', value)
        }
    }
}